import React from 'react';

const SEVERITY_TONE = {
  high: 'bg-red-950/40 border-red-900 text-red-200',
  medium: 'bg-amber-950/40 border-amber-900 text-amber-200',
  low: 'bg-neutral-900 border-neutral-800 text-neutral-300',
};

export default function InsightsPanel({ insight }) {
  if (!insight) {
    return (
      <div className="rounded border border-neutral-800 bg-neutral-900 px-6 py-8 text-center">
        <p className="text-sm text-neutral-500">
          AI insights will appear after the first portfolio sync.
        </p>
      </div>
    );
  }

  const { content, generated_at, model } = insight;
  const flags = content?.risk_flags || [];
  const opps = content?.opportunities || [];

  return (
    <div className="space-y-4">
      <div className="rounded border border-neutral-800 bg-neutral-900 px-5 py-4">
        <p className="text-xs uppercase tracking-wide text-neutral-500 mb-2">
          Allocation read
        </p>
        <p className="text-neutral-100 leading-relaxed">
          {content?.allocation_assessment}
        </p>
      </div>

      {flags.length > 0 && (
        <div>
          <p className="text-xs uppercase tracking-wide text-neutral-500 mb-2">
            Risks
          </p>
          <div className="space-y-2">
            {flags.map((f, i) => (
              <div
                key={i}
                className={`rounded border px-4 py-3 ${SEVERITY_TONE[f.severity] || SEVERITY_TONE.low}`}
              >
                <div className="flex items-start gap-2">
                  <span className="text-xs uppercase tracking-wide opacity-70 mt-0.5">
                    {f.severity}
                  </span>
                  <div className="flex-1">
                    <p className="font-medium">{f.flag}</p>
                    <p className="text-sm opacity-80 mt-1">{f.reason}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {opps.length > 0 && (
        <div>
          <p className="text-xs uppercase tracking-wide text-neutral-500 mb-2">
            Opportunities
          </p>
          <div className="space-y-2">
            {opps.map((o, i) => (
              <div
                key={i}
                className="rounded border border-emerald-900 bg-emerald-950/30 px-4 py-3 text-emerald-100"
              >
                <p className="font-medium">{o.opportunity}</p>
                <p className="text-sm opacity-80 mt-1">{o.reason}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <p className="text-xs text-neutral-500 text-right">
        Generated {new Date(generated_at).toLocaleString()} · {model}
      </p>
    </div>
  );
}
